module.exports = __webpack_public_path__ + "static/media/magento.0c1c9e14.svg";